<template>
  <div id="charge">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted () {
    this.$emit('setMenu', 'Charge')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/charge/Charge.vue